// Auto-generated from cars_ds_final.csv
export interface CarBrand {
  brand: string;
  models: string[];
}

export const carDataset: CarBrand[] = [
  {
    "brand": "Aston Martin",
    "models": [
      "Db 11",
      "Rapide",
      "Vantage"
    ]
  },
  {
    "brand": "Audi",
    "models": [
      "A3",
      "A3 Cabriolet",
      "A4",
      "A5",
      "A5 Cabriolet",
      "A6",
      "A8 L",
      "Q3",
      "Q5",
      "Q7",
      "Q8",
      "R8",
      "Rs5",
      "Rs7",
      "S5"
    ]
  },
  {
    "brand": "Bajaj",
    "models": [
      "Qute (Re60)"
    ]
  },
  {
    "brand": "Bentley",
    "models": [
      "Bentayga",
      "Continental Gt",
      "Flying Spur",
      "Mulsanne"
    ]
  },
  {
    "brand": "Bmw",
    "models": [
      "3-Series",
      "5-Series",
      "6-Series",
      "7-Series",
      "M2 Competition",
      "M4",
      "M5",
      "X1",
      "X3",
      "X4",
      "X5",
      "X7",
      "Z4 Roadster"
    ]
  },
  {
    "brand": "Bugatti",
    "models": [
      "Chiron"
    ]
  },
  {
    "brand": "Datsun",
    "models": [
      "Go",
      "Redi-Go"
    ]
  },
  {
    "brand": "Dc",
    "models": [
      "Avanti"
    ]
  },
  {
    "brand": "Ferrari",
    "models": [
      "458 Speciale",
      "458 Spider",
      "488 Gtb",
      "812 Superfast",
      "Gtc4 Lusso",
      "Portofino"
    ]
  },
  {
    "brand": "Fiat",
    "models": [
      "Abarth Avventura",
      "Abarth Punto",
      "Avventura",
      "Linea",
      "Linea Classic",
      "Punto Evo",
      "Punto Evo Pure",
      "Urban Cross"
    ]
  },
  {
    "brand": "Force",
    "models": [
      "Gurkha"
    ]
  },
  {
    "brand": "Ford",
    "models": [
      "Aspire",
      "Ecosport",
      "Endeavour",
      "Figo",
      "Freestyle",
      "Mustang"
    ]
  },
  {
    "brand": "Honda",
    "models": [
      "Accord Hybrid",
      "Amaze",
      "Brv",
      "City",
      "Civic",
      "Cr-V",
      "Jazz",
      "Wr-V"
    ]
  },
  {
    "brand": "Hyundai",
    "models": [
      "Aura",
      "Creta",
      "Elantra",
      "Elite I20",
      "Grand I10",
      "Grand I10 Nios",
      "Grand I10 Prime",
      "I20 Active",
      "Kona Electric",
      "Santro",
      "Tucson",
      "Venue",
      "Verna",
      "Xcent",
      "Xcent Prime"
    ]
  },
  {
    "brand": "Icml",
    "models": [
      "Extreme"
    ]
  },
  {
    "brand": "Isuzu",
    "models": [
      "Dmax V-Cross",
      "Mu-X"
    ]
  },
  {
    "brand": "Jaguar",
    "models": [
      "F-Pace",
      "F-Type",
      "Xe",
      "Xf",
      "Xj"
    ]
  },
  {
    "brand": "Jeep",
    "models": [
      "Compass",
      "Compass Trailhawk",
      "Grand Cherokee",
      "Wrangler"
    ]
  },
  {
    "brand": "Kia",
    "models": [
      "Carnival",
      "Seltos"
    ]
  },
  {
    "brand": "Lamborghini",
    "models": [
      "Aventador",
      "Huracan",
      "Urus"
    ]
  },
  {
    "brand": "Land Rover",
    "models": [
      "Discovery",
      "Discovery Sport"
    ]
  },
  {
    "brand": "Land Rover Rover",
    "models": [
      "Range",
      "Range Evoque",
      "Range Evoque Convertible",
      "Range Sport",
      "Range Velar"
    ]
  },
  {
    "brand": "Lexus",
    "models": [
      "Es",
      "Lc 500H",
      "Ls 500H",
      "Lx 450D",
      "Lx 570",
      "Nx 300H",
      "Rx 450H"
    ]
  },
  {
    "brand": "Mahindra",
    "models": [
      "Alturas G4",
      "Bolero",
      "Bolero Power Plus",
      "E Verito",
      "E2O Plus",
      "Kuv100 Nxt",
      "Marazzo",
      "Nuvosport",
      "Scorpio",
      "Thar",
      "Tuv300",
      "Tuv300 Plus",
      "Verito",
      "Verito Vibe",
      "Xuv300",
      "Xuv500",
      "Xylo"
    ]
  },
  {
    "brand": "Maruti Suzuki",
    "models": [
      "Alto",
      "Alto 800 Tour",
      "Alto K10",
      "Baleno",
      "Baleno Rs",
      "Celerio",
      "Celerio Tour",
      "Celerio X",
      "Ciaz",
      "Dzire",
      "Dzire Tour",
      "Eeco",
      "Ertiga",
      "Gypsy",
      "Ignis",
      "Omni",
      "S-Cross",
      "S-Presso",
      "Swift",
      "Vitara Brezza",
      "Xl6"
    ]
  },
  {
    "brand": "Maruti Suzuki R",
    "models": [
      "Wagon"
    ]
  },
  {
    "brand": "Maserati",
    "models": [
      "Ghibli",
      "Grancabrio",
      "Granturismo",
      "Levante",
      "Quattroporte"
    ]
  },
  {
    "brand": "Mg",
    "models": [
      "Hector",
      "Zs Ev"
    ]
  },
  {
    "brand": "Mini",
    "models": [
      "Clubman",
      "Convertible",
      "Cooper 3 Door",
      "Cooper 5 Door",
      "Countryman",
      "John Cooper Works"
    ]
  },
  {
    "brand": "Mitsubishi",
    "models": [
      "Montero",
      "Outlander",
      "Pajero Sport"
    ]
  },
  {
    "brand": "Nissan",
    "models": [
      "Gtr",
      "Kicks",
      "Micra",
      "Micra Active",
      "Sunny",
      "Terrano"
    ]
  },
  {
    "brand": "Porsche",
    "models": [
      "718",
      "911",
      "Cayenne",
      "Cayenne Coupe",
      "Macan",
      "Panamera"
    ]
  },
  {
    "brand": "Premier",
    "models": [
      "Rio"
    ]
  },
  {
    "brand": "Renault",
    "models": [
      "Captur",
      "Duster",
      "Kwid",
      "Lodgy",
      "Triber"
    ]
  },
  {
    "brand": "Skoda",
    "models": [
      "Kodiaq",
      "Kodiaq Scout",
      "Monte Carlo",
      "Octavia",
      "Rapid",
      "Superb",
      "Superb Sportline"
    ]
  },
  {
    "brand": "Tata",
    "models": [
      "Altroz",
      "Bolt",
      "Harrier",
      "Hexa",
      "Nano Genx",
      "Nexon",
      "Nexon Ev",
      "Safari Storme",
      "Tiago",
      "Tiago Nrg",
      "Tigor",
      "Tigor Ev",
      "Winger",
      "Zest"
    ]
  },
  {
    "brand": "Toyota",
    "models": [
      "Camry",
      "Corolla Altis",
      "Etios Cross",
      "Etios Liva",
      "Fortuner",
      "Glanza",
      "Innova Crysta",
      "Land Cruiser",
      "Land Cruiser Prado",
      "Platinum Etios",
      "Prius",
      "Yaris"
    ]
  },
  {
    "brand": "Volkswagen",
    "models": [
      "Ameo",
      "Passat",
      "Polo",
      "Tiguan",
      "Vento"
    ]
  },
  {
    "brand": "Volvo",
    "models": [
      "S60",
      "S60 Cross Country",
      "S90",
      "V40",
      "V40 Cross Country",
      "V90 Cross Country",
      "Xc40",
      "Xc60",
      "Xc90"
    ]
  }
];

export const basicColors: string[] = [
  "White",
  "Black",
  "Silver",
  "Grey",
  "Red",
  "Blue",
  "Brown",
  "Gold",
  "Green",
  "Orange",
  "Yellow",
  "Bronze",
  "Purple",
  "Beige"
];
